import { AccordionItem, List, Stack, Strong, Text } from 'braid-design-system';

export const TermAndTermination = () => (
  <AccordionItem id="term-and-termination" label="Term and Termination">
    <List type="number" start={49}>
      <Text>
        The “<Strong>Term</Strong>” of these Terms commences from the date which
        you agree to these Terms and will continue until terminated in
        accordance with clause 50, 51 or 53, set out below.
      </Text>
      <Stack space="medium">
        <Text>
          We reserve the right to, in our absolute discretion but acting
          reasonably, immediately suspend your Licence if:
        </Text>
        <List type="alpha">
          <Text>you breach the warranties in clause 31;</Text>
          <Text>you breach the privacy obligations in clause 34;</Text>
          <Text>you breach any applicable laws;</Text>
          <Text>
            SEEK reasonably believes that you pose a security threat in any way
            (including in relation to candidates or our systems); or
          </Text>
          <Text>
            SEEK reasonably believes that you have caused, or are likely to
            cause, damage to our brand or reputation.
          </Text>
        </List>
      </Stack>
      <Text>
        Either party may terminate these Terms by written notice if the other
        party materially breaches any of these Terms and does not remedy such
        breach within 14 days of being notified to do so.
      </Text>
      <Text>
        Termination of our agreement with you as a result of you breaching any
        one or more of these Terms, will not end provisions of these Terms that
        are capable of surviving termination.
      </Text>
      <Text>
        Either party may terminate these Terms at any time by providing the
        other party with 60 days&apos; prior written notice.
      </Text>
    </List>
  </AccordionItem>
);
